<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import debounce from 'lodash/debounce'

const IS_FIREFOX = navigator.userAgent.toLowerCase().indexOf('firefox') > -1
const IS_MAC = navigator.platform.toUpperCase().indexOf('MAC') >= 0
const MOUSEWHEEL = IS_FIREFOX ? 'DOMMouseScroll' : 'mousewheel'

export default {

  name: 'Scroller',

  props: {
    threshold: {
      type: Number,
      default: 150
    },
    block: {
      type: Boolean,
      default: false
    },
    global: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      enabled: false,
      timer: null,
      lastDelta: 0,
      lastTime: 0,
      lastDiff: 0,
      lastInitialScroll: 0
    }
  },

  computed: {
    onSlideDebounced () {
      return debounce(function (callback) {
        callback()
      }, this.threshold, { leading: true, trailing: false })
    }
  },

  created () {
    this.$on('enable', this.enable)
    this.$on('disable', this.disable)
  },

  mounted () {
    //scroller off
    this.enable()
  },

  beforeDestroy () {
    this.$off()
    this.disable()
  },

  methods: {
    enable () {
      if (this.global) {
        document.addEventListener(MOUSEWHEEL, this.onScroll)
      } else {
        this.$el.addEventListener(MOUSEWHEEL, this.onScroll)
      }

      this.enabled = true
    },

    disable () {
      if (this.global) {
        document.removeEventListener(MOUSEWHEEL, this.onScroll)
      } else {
        this.$el.removeEventListener(MOUSEWHEEL, this.onScroll)
      }

      this.enabled = false
    },

    onScroll (event) {
      event.preventDefault()

      let delta = 0

      if (!event) event = window.event

      if (event.wheelDelta) {
        delta = event.wheelDelta / 120
      } else if (event.detail) {
        delta = -event.detail / 3
      }


      delta = delta.toFixed(2)


      const threshold = IS_FIREFOX ? 300 : 50
      const isFiredFast = event.timeStamp - this.lastTime < threshold
      const isDecreasing = Math.abs(delta) <= Math.abs(this.lastDelta)
      const isDifferenceThrustful = event.timeStamp - this.lastInitialScroll > threshold && Math.abs(delta) - Math.abs(this.lastDelta) > 0.5
      const isInitialScroll = !(isFiredFast && isDecreasing) && isDifferenceThrustful

      console.log(event.timeStamp - this.lastInitialScroll > threshold && Math.abs(delta) - Math.abs(this.lastDelta) > 0.5);

      if (isInitialScroll) {
        console.log('initial scroll')
        const direction = delta - this.lastDelta <= 0
        this.onInitialScroll(direction)
      }

      this.lastDelta = delta
      this.lastDiff = (event.timeStamp - this.lastTime).toFixed(2)
      this.lastTime = event.timeStamp

      if (this.timer !== null) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.timer = setTimeout(() => {
        this.lastDelta = 0
        clearTimeout(this.timer)
        this.timer = null
      }, 30)
    },

    /**
     * @param      {<bollean>}  direction  If true - scroll goes down
     */
    onInitialScroll (direction) {
      this.$emit('scroll', direction)

      if (!this.block) {
        this.onSlide(direction)
      }
    },

    onSlide (direction) {
      this.onSlideDebounced(() => {
        this.$emit('slide', direction)

        if (direction) {
          this.$emit('slide-down')
        } else {
          this.$emit('slide-up')
        }
      })
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.scroller-container
  slot

</template>



// WEBPACK FOOTER //
// scroller.vue?3e394c2e